<template>
  <ym-button class="seckill-btn-component"
             :class="[
               `seckill-btn--${type}`,
               `seckill-btn--${size}`,
               { 'is-plain': plain },
             ]"
             :size="size"
             :disabled="disabled"
             round
             @click="handleClick"
  >
    <slot></slot>
  </ym-button>
</template>

<script>
  import { Button } from '@ymba/ym-ui';

  export default {
    name: 'SeckillBtn',
    components: {
      'ym-button': Button,
    },
    props: {
      type: {
        type: String,
        default: 'gradient',
        validator(val) {
          return [
            'gradient',
            'primary',
          ].includes(val);
        },
      },
      size: {
        type: String,
        default: 'medium',
        validator(val) {
          return [
            'small',
            'medium',
          ].includes(val);
        },
      },
      plain: Boolean,
      disabled: Boolean,
    },
    methods: {
      handleClick(e) {
        this.$emit('click', e);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .seckill-btn {
    &-component {
      width: auto;
    }

    &--gradient {
      color: @color-white;
      background: @seckill-primary-gradient;
      border: none;
    }

    &--primary {
      color: @seckill-highlight;
      background: @seckill-lighter;

      &.is-plain {
        background: none;
        border: 1px solid @seckill-highlight;
      }

      &.is-disabled {
        opacity: 1;
      }
    }

    &--medium {
      font-size: @font-size-large;
      padding: 0 @size-large;
    }
  }
</style>
